import { render, staticRenderFns } from "./CoTwoTransportationShootingForm.vue?vue&type=template&id=24b03f04&scoped=true&"
import script from "./CoTwoTransportationShootingForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoTransportationShootingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b03f04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b03f04')) {
      api.createRecord('24b03f04', component.options)
    } else {
      api.reload('24b03f04', component.options)
    }
    module.hot.accept("./CoTwoTransportationShootingForm.vue?vue&type=template&id=24b03f04&scoped=true&", function () {
      api.rerender('24b03f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoTransportationShootingForm.vue"
export default component.exports